module.exports = __webpack_public_path__ + "static/media/thumbsup.8432178f.svg";